import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'

import { resolvePageComponent, setupZiggy } from '@react-helpers'


// NOTE: awaiting or voiding this promise causes the app to not render
// noinspection JSIgnoredPromiseFromCall
createInertiaApp({
    id: 'inertia',
    resolve: (path) => resolvePageComponent(
        `./domains/${path}.tsx`,
        import.meta.glob(`./domains/**/pages/**/*.tsx`),
    ),
    setup({ el, App, props }) {
        setupZiggy(props.initialPage.props)
        el.removeAttribute('data-page')

        // hydrateRoot(el, <App {...props} />)
        createRoot(el).render(<App {...props} />)
    },
})
